import { NgModule } from '@angular/core';
import { CoreUiModule } from 'webcommon/core-ui';
import { FindControlModule } from 'webcommon/find-control';
import { MacroModule } from 'webcommon/macro';
import { HtmlEditorModule } from 'webcommon/html-editor';
import { WindowRef } from './attachment-approval/window-ref.service';
import {
  ApCcmComponent,
  AttachmentApprovalComponent,
  AttachmentApprovalDetailComponent,
  MessageReadMoreComponent,
} from './attachment-approval';
import {
  MessageStrikeoutModalComponent,
} from './message-strikeout';
import {
  MessageTaskComponent,
  MessageTaskModalComponent,
} from './message-task';
import {
  MessageNoteModalComponent,
} from './msg-note';
import {
  ApMessageEditorComponent,
  ApMessageThreadComponent,
  ApMessageThreadMessageComponent,
} from './ap-message';

const exportComponents = [
  ApCcmComponent,
  AttachmentApprovalDetailComponent,
  MessageTaskComponent,
  MessageNoteModalComponent,
  AttachmentApprovalComponent,
  MessageReadMoreComponent,
  MessageTaskModalComponent,
  MessageStrikeoutModalComponent,
  ApMessageEditorComponent,
  ApMessageThreadComponent,
  ApMessageThreadMessageComponent,
];

const declareComponents = [
  exportComponents,
];

@NgModule({
  declarations: [
    declareComponents,
  ],
  exports: [
    exportComponents,
  ],
  imports: [
    CoreUiModule,
    FindControlModule,
    MacroModule,
    HtmlEditorModule
  ],
  providers: [WindowRef],
})
export class MessagesModule {

}
